export default __webpack_public_path__ + "static/unity-701a2057e4d2b9de28cbbcb795db6c09.jpg";